export const products = [
  {
    id: "accounting",
    name: "EasyBooks Accounting",
    to: "/EasyBooks_Accounting",
    tagline: "Accounting that stays out of your way.",
    description:
      "A simple, secure, web-based accounting package built for SMEs and institutions run it on-premise or in the cloud.",
    imageSrc: "Assets/eb-accounting.webp",
    heroSrc: "Assets/Products/accounting-pc.png",
    highlights: ["Multi-company support", "Customizable workflows", "Budgeting & reporting", "Secure access controls"],
  },
  {
    id: "erp",
    name: "EasyBooks ERP",
    to: "/EasyBooks_ERP",
    tagline: "Automate workflows. Improve control.",
    description:
      "Streamline finance, procurement, HR, and operations with a modern ERP that helps teams move faster with fewer errors.",
    imageSrc: "Assets/eb-automation.png",
    heroSrc: "Assets/Products/automation-pc.png",
    highlights: ["Budget control", "Integrated payments", "Procurement digitization", "HR & payroll"],
  },
  {
    id: "imeris",
    name: "EasyBooks IMERIS",
    to: "/EasyBooks_IMERIS",
    tagline: "Connected care with a unified health platform.",
    description:
      "A holistic ecosystem that brings EHR, billing, accounting, payroll, and inventory into one secure, compliant system.",
    imageSrc: "Assets/eb-imeris.png",
    heroSrc: "Assets/Products/Imeris-pc.png",
    highlights: ["EHR + billing", "Clinical workflow automation", "Inventory integration", "Strong security controls"],
  },
];

